import React from 'react';
import Slider from "react-slick";
import Footer from "../Footer";

const bars = (props) => {
  const barList = {
    "EMBASSY": "embassy_gallery",
    "MINE": "mine_gallery",
    "MAZE BAR": "maze_gallery",
    "LOCKHART 88": "lockhart_gallery",
    "PORT": "port_gallery",
    "TABOO": "taboo_gallery",
    // "GRAFFITI": "graffiti_gallery", // Hidden
    "GATE": "gate_gallery",
    "THE STATION": "the_station_gallery",
    "CENTRICO": "centrico_gallery",
  }
  let lastPath = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)
  if (lastPath.indexOf('%20') > 0) {
    lastPath = lastPath.split('%20').join(' ')
  }
  const ownOutlet = props.galleryCategories.filter((outlet) => { return outlet.name === barList[lastPath] })

  const rowSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3.9999,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };
  return props === undefined ?
    <div className="loading"></div> : (
      <>
        <div className="insideGallery">
          <div className="container-fluid gallerySlide">
            <div className="row paddingSlider">
              <h4 className='ownGallery'> {lastPath} </h4>
              <Slider {...rowSlider} className="ownGallerySlider">
                {ownOutlet[0].galleries.map((gallery, index) => {
                  return (
                    <div key={lastPath + index} className="galleryImages"><img src={process.env.REACT_APP_IMAGE_STORAGE + gallery.image} alt="" className="galleryImage" /></div>
                  )
                })}
              </Slider>
            </div>
          </div>
        </div>
        <div className="footer d-lg-none">
          <Footer />
        </div>
      </>
    );
};

export default bars;